// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'backspace';

export const Component = () => (
  <path d='m2.533 11.945 6.705 5.843H21.64c.24 0 .48-.097.67-.336a.946.946 0 0 0 .288-.67V6.964a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.288H9.237l-6.705 5.94v-.001Zm19.11 6.8H8.854L1 11.945 8.855 5h12.787c.527 0 1.006.191 1.39.575.383.384.574.862.574 1.39v9.817c0 .527-.191 1.006-.575 1.39a1.917 1.917 0 0 1-1.389.574ZM17.714 8.257l-2.97 2.921-2.92-2.921-.72.67 2.97 2.97-2.97 2.921.72.719 2.92-2.97 2.97 2.97.67-.719-2.92-2.921 2.92-2.97-.67-.67Z' />
);

export const viewBox = '0 0 25 25';
